import statsConfig_25_06_2021 from "./statsConfigs/statsConfig_26_06_2021";

export default ()=> {
    return statsConfig_25_06_2021;
}